import * as React from 'react'
import { ReactElement } from 'react'
import ReportForm from './ReportForm'
import { DateTime } from 'luxon'
import { useFormikContext } from 'formik'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'
import FormikField from '../../../Formik/FormikField'
import UserPicker, { UserPickerProps } from '../../../TagPicker/UserPicker'
import { useTranslation } from 'react-i18next'
import DateRange from '../../../DatePicker/DateRange'
import * as Yup from 'yup'
import { ReportFormType } from '../../../../pages/Finance/Reports'

export type WipReportDto = {
    from: string
    to: string
    timeOwners: string[]
    fileOwners: string[]
}

const getValidationSchema = (translate: (key: string) => string): Yup.ObjectSchema<WipReportDto> => {
    return Yup.object().shape({
        from: Yup.string().label(translate('base.daterange')).required(),
        to: Yup.string().label(translate('base.daterange')).required(),
        fileOwners: Yup.array().label(translate('file.filter.owner')).required(),
        timeOwners: Yup.array().label(translate('file.filter.executive')).required(),
    })
}

function ReportBody(props: ReportFormType): ReactElement {
    const { errors, values, setFieldValue } = useFormikContext<WipReportDto>()

    return (
        <>
            <DateRange
                startValue={values.from}
                endValue={values.to}
                changeStartDate={date => setFieldValue('from', date)}
                changeEndDate={date => setFieldValue('to', date)}
                orientation={props.orientation}
                required
                showLabel
                validationMessage={errors.from || errors.to}
            />

            <FormikField<UserPickerProps, WipReportDto>
                orientation={props.orientation}
                labelKey="file.filter.owner"
                fieldName={'fileOwners'}
                component={UserPicker}
                componentProps={{
                    selectedOptions: values.fileOwners,
                    onOptionsSelect: (_, selectedOptions) => setFieldValue('fileOwners', selectedOptions),
                }}
            />
            <FormikField<UserPickerProps, WipReportDto>
                orientation={props.orientation}
                labelKey="file.filter.executive"
                fieldName={'timeOwners'}
                component={UserPicker}
                componentProps={{
                    selectedOptions: values.timeOwners,
                    onOptionsSelect: (_, selectedOptions) => setFieldValue('timeOwners', selectedOptions),
                }}
            />
        </>
    )
}

export default function WipReportForm(props: ReportFormType): ReactElement {
    const { t: translate } = useTranslation()

    return (
        <ReportForm<WipReportDto>
            title="Onderhanden werk"
            generationType={DocumentGenerationType.WipPosition}
            initialValues={{
                from: DateTime.local().minus({ months: 12 }).startOf('month').toISODate(),
                to: DateTime.local().toISODate(),
                timeOwners: [],
                fileOwners: [],
            }}
            validationSchema={getValidationSchema(translate)}
            {...props}
        >
            <ReportBody {...props} />
        </ReportForm>
    )
}
